import { render, staticRenderFns } from "./setLogo.vue?vue&type=template&id=aef3f592&"
import script from "./setLogo.vue?vue&type=script&lang=js&"
export * from "./setLogo.vue?vue&type=script&lang=js&"
import style0 from "./setLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports